import { render, staticRenderFns } from "./store-offer-list-table.vue?vue&type=template&id=35d11d64&"
import script from "./store-offer-list-table.vue?vue&type=script&lang=js&"
export * from "./store-offer-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn,QTooltip,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn,QTooltip,QCard})
